import React, { useState } from 'react';
import api from '../../../api';
import './ReceiverPowerModal.css';

// Import fossil image
import fossilImg from '../../../assets/images/items/fossil.png';

// Drill image is in public folder
const drillImg = '/Maps/objects_maps/drill.png';
const berryFusionImg = '/Maps/objects_maps/berryfusion.png';
const kingRockImg = '/Maps/objects_maps/kingrock.png';

export default function ResearcherModal({ 
  researchPlacementId,
  researchUnlocks,
  onClose,
  onUnlockSuccess
}) {
  const [unlocking, setUnlocking] = useState(false);
  const [userFossils, setUserFossils] = useState(0);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [unlockedItem, setUnlockedItem] = useState(null);

  // Fetch user's fossil count
  React.useEffect(() => {
    const fetchFossils = async () => {
      try {
        const res = await api.get('/v1/inventory', { withCredentials: true });
        const fossilItem = (res?.data || []).find(item => Number(item.item) === 144);
        const fossilCount = Number(fossilItem?.amount) || 0;
        setUserFossils(fossilCount);
      } catch (e) {
        console.error('Failed to fetch fossils:', e);
      }
    };
    fetchFossils();
  }, []);

  const handleUnlock = async (unlockKey) => {
    if (unlocking) return;
    
    setUnlocking(true);
    try {
      const res = await api.post('/v1/island/research/unlock', {
        unlock_key: unlockKey,
        map_id: 103
      }, {
        withCredentials: true
      });
      
      if (res?.data?.success) {
        setUnlockedItem(res.data);
        setShowSuccessModal(true);
        const fossilItem = (await api.get('/v1/inventory', { withCredentials: true }))?.data?.find(item => Number(item.item) === 144);
        setUserFossils(Number(fossilItem?.amount) || 0);
      }
    } catch (e) {
      const msg = e?.response?.data?.detail || 'Failed to unlock';
      alert(msg);
    } finally {
      setUnlocking(false);
    }
  };

  const unlocks = researchUnlocks?.unlocks || [];

  return (
    <div
      className="receiver-power-overlay"
      onClick={onClose}
    >
      <div
        className="receiver-power-modal"
        onClick={(e) => e.stopPropagation()}
        style={{ maxWidth: 500 }}
      >
        <div className="receiver-power-header">
          <div className="receiver-power-title">🔬 Research Building</div>
          <button
            onClick={onClose}
            className="receiver-power-close"
          >
            ✕
          </button>
        </div>

        <div className="receiver-power-content">
          <div className="receiver-section">
            <div className="receiver-section-title">Available Research</div>
            <div className="receiver-section-subtitle">
              Unlock new features by spending fossils
            </div>

            {unlocks.length === 0 ? (
              <div style={{ padding: 16, textAlign: 'center', color: '#9ca3af' }}>
                Loading research options...
              </div>
            ) : (
              <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
                {unlocks.map(unlock => (
                  <div
                    key={unlock.key}
                    style={{
                      background: unlock.unlocked ? 'rgba(16, 185, 129, 0.1)' : 'rgba(17, 24, 39, 0.6)',
                      border: unlock.unlocked ? '2px solid #10b981' : '2px solid #374151',
                      borderRadius: 8,
                      padding: 16,
                      display: 'flex',
                      flexDirection: 'column',
                      gap: 12
                    }}
                  >
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 12 }}>
                      {unlock.key === 'drill' && (
                        <img 
                          src={drillImg}
                          alt="Drill"
                          style={{
                            width: 48,
                            height: 48,
                            imageRendering: 'pixelated',
                            border: '2px solid #374151',
                            borderRadius: 6,
                            background: 'rgba(0, 0, 0, 0.3)'
                          }}
                          onError={(e) => {
                            e.currentTarget.style.display = 'none';
                          }}
                        />
                      )}
                      {unlock.key === 'berryfusion' && (
                        <img 
                          src={berryFusionImg}
                          alt="Berry Fusion Station"
                          style={{
                            width: 48,
                            height: 48,
                            imageRendering: 'pixelated',
                            border: '2px solid #374151',
                            borderRadius: 6,
                            background: 'rgba(0, 0, 0, 0.3)'
                          }}
                          onError={(e) => {
                            e.currentTarget.style.display = 'none';
                          }}
                        />
                      )}
                      {unlock.key === 'kingrock' && (
                        <img 
                          src={kingRockImg}
                          alt="King Rock"
                          style={{
                            width: 48,
                            height: 48,
                            imageRendering: 'pixelated',
                            border: '2px solid #374151',
                            borderRadius: 6,
                            background: 'rgba(0, 0, 0, 0.3)'
                          }}
                          onError={(e) => {
                            e.currentTarget.style.display = 'none';
                          }}
                        />
                      )}
                      <div style={{ flex: 1 }}>
                        <div style={{ 
                          fontSize: 16, 
                          fontWeight: 'bold', 
                          color: unlock.unlocked ? '#10b981' : '#fff',
                          marginBottom: 4
                        }}>
                          {unlock.name}
                          {unlock.unlocked && <span style={{ marginLeft: 8, fontSize: 14 }}>✓</span>}
                        </div>
                        <div style={{ fontSize: 13, color: '#9ca3af', lineHeight: 1.5 }}>
                          {unlock.description}
                        </div>
                      </div>
                    </div>

                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                      <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                          <img 
                            src={fossilImg} 
                            alt="Fossil"
                            style={{
                              width: 24,
                              height: 24,
                              imageRendering: 'pixelated'
                            }}
                            onError={(e) => {
                              e.currentTarget.style.display = 'none';
                            }}
                          />
                          <span style={{ color: '#fbbf24', fontWeight: 'bold', fontSize: 14 }}>
                            {unlock.cost_fossils} Fossils
                          </span>
                        </div>
                        <div style={{ fontSize: 12, color: '#9ca3af', marginLeft: 32 }}>
                          You have: {userFossils} fossils
                        </div>
                      </div>

                      {!unlock.unlocked && (
                        <button
                          onClick={() => handleUnlock(unlock.key)}
                          disabled={unlocking || userFossils < unlock.cost_fossils}
                          style={{
                            background: userFossils < unlock.cost_fossils ? '#6b7280' : '#10b981',
                            color: '#fff',
                            border: 'none',
                            borderRadius: 6,
                            padding: '8px 16px',
                            fontSize: 14,
                            fontWeight: 'bold',
                            cursor: (unlocking || userFossils < unlock.cost_fossils) ? 'not-allowed' : 'pointer',
                            opacity: (unlocking || userFossils < unlock.cost_fossils) ? 0.6 : 1,
                            transition: 'all 0.2s'
                          }}
                        >
                          {unlocking ? 'Unlocking...' : userFossils < unlock.cost_fossils ? 'Not Enough Fossils' : 'Unlock'}
                        </button>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>

          <div className="receiver-section">
            <div className="receiver-section-title">Info</div>
            <div style={{ fontSize: 13, color: '#9ca3af', lineHeight: 1.6 }}>
              <div>• Research building requires 600,000 voltage per day</div>
              <div>• Fossils can be found by mining rocks on My Island (1/200 chance)</div>
              <div>• Unlocked features are permanent and apply to all your islands</div>
            </div>
          </div>
        </div>
      </div>

      {showSuccessModal && unlockedItem && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'rgba(0, 0, 0, 0.7)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 10000,
          }}
          onClick={() => {
            setShowSuccessModal(false);
            setUnlockedItem(null);
            if (onUnlockSuccess) {
              onUnlockSuccess();
            }
            window.location.reload();
          }}
        >
          <div
            style={{
              background: 'linear-gradient(135deg, #1e293b 0%, #0f172a 100%)',
              border: '2px solid #10b981',
              borderRadius: 16,
              padding: 32,
              maxWidth: 400,
              textAlign: 'center',
              boxShadow: '0 0 40px rgba(16, 185, 129, 0.3)',
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <div style={{ fontSize: 48, marginBottom: 16 }}>✓</div>
            <div style={{ fontSize: 24, fontWeight: 'bold', color: '#10b981', marginBottom: 8 }}>
              Research Unlocked!
            </div>
            <div style={{ fontSize: 18, color: '#fff', marginBottom: 16 }}>
              {unlockedItem.name}
            </div>
            <div style={{ fontSize: 14, color: '#9ca3af', marginBottom: 24 }}>
              Spent {unlockedItem.fossils_spent} fossils
              <br />
              Remaining: {unlockedItem.fossils_remaining} fossils
            </div>
            <button
              onClick={() => {
                setShowSuccessModal(false);
                setUnlockedItem(null);
                if (onUnlockSuccess) {
                  onUnlockSuccess();
                }
                window.location.reload();
              }}
              style={{
                background: '#10b981',
                color: '#fff',
                border: 'none',
                borderRadius: 8,
                padding: '12px 24px',
                fontSize: 16,
                fontWeight: 'bold',
                cursor: 'pointer',
              }}
            >
              Continue
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
